import { connect } from 'react-redux'
import { preventDefault } from 'src/helpers/utils'
import { closeModal, changeVehicleUpdateHandler, updateGarage } from '../actions'
import VehicleEditorButtons from './VehicleEditorButtons'

const mapDispatchToProps = (dispatch, { handleUpdate }) => ({
  closeModal: preventDefault(() => dispatch(closeModal())),
  updateVehicle() {
    dispatch(changeVehicleUpdateHandler(updateGarage))

    handleUpdate && handleUpdate()
  }
})

export default connect(null, mapDispatchToProps)(VehicleEditorButtons)
